var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdModal from "@frameworks/web/components/generic/edModal";
import Drawer from "react-bottom-drawer";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton, WhatsappIcon, EmailIcon, EmailShareButton, InstapaperShareButton, InstapaperIcon, } from "react-share";
import { FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
import "@frameworks/shared-library/stylesheets/components/shareSocialLinks.scss";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var ShareSocialLinks = function (props) {
    var device = DeviceContext();
    var _a = __read(React.useState("Copy to clipboard"), 2), tooltiptext = _a[0], settooltiptext = _a[1];
    var _b = __read(React.useState(true), 2), showShareLinks = _b[0], setshowShareLinks = _b[1];
    var ClipboardCopy = function () {
        var clipboard = document.getElementById("myInput");
        navigator.clipboard.writeText(clipboard.value);
        settooltiptext("copied");
    };
    React.useEffect(function () {
        // di.footer.updateShowMob_Menu(false);
        // di.header.RemoveHeaderData(false);
        props === null || props === void 0 ? void 0 : props.setShare(showShareLinks);
    }, [showShareLinks]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "shareSocialLinks" }, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(EdModal, { show: showShareLinks, setShow: setshowShareLinks, modalTitle: "modalShareTitle", size: "modal-dialog-centered", title: "Share On", showFooter: false },
            React.createElement("div", { className: "d-flex align-items-center justify-content-center" },
                React.createElement("div", { className: "instagram" },
                    React.createElement(InstapaperShareButton, { url: props.value, className: "share_button" },
                        React.createElement(InstapaperIcon, { size: 32 }))),
                React.createElement("div", { className: "twitter" },
                    React.createElement(TwitterShareButton, { title: "", url: props.value, hashtags: ["hashtag1", "hashtag2"], className: "share_button" },
                        React.createElement(TwitterIcon, { size: 32 }))),
                React.createElement("div", { className: "gmail" },
                    React.createElement(EmailShareButton, { url: props.value, className: "share_button", onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open("mailto:?subject=Check this out&body=".concat(props.value), "_blank");
                        } },
                        React.createElement(EmailIcon, { size: 32 }))),
                React.createElement("div", { className: "linkedIn" },
                    React.createElement(LinkedinShareButton, { title: "", url: props.value, className: "share_button" },
                        React.createElement(LinkedinIcon, { size: 32 }))),
                React.createElement("div", { className: "facebook" },
                    React.createElement(FacebookShareButton, { url: props.value, hashtag: "#hashtag", className: "share_button" },
                        React.createElement(FacebookIcon, { size: 32 }))),
                React.createElement("div", { className: "whatsapp" },
                    React.createElement(WhatsappShareButton, { title: "", url: props.value, className: "share_button" },
                        React.createElement(WhatsappIcon, { size: 32 })))),
            React.createElement("div", { className: "copyLink" },
                React.createElement("div", { className: "copyLink_wrap" },
                    React.createElement("h6", null, "Copy this url to share"),
                    props.value.split("\n").map(function (z) {
                        return (React.createElement("div", { className: "copyLink--input" },
                            React.createElement("input", { type: "text", value: z, id: "myInput" }),
                            React.createElement("button", { onClick: ClipboardCopy },
                                React.createElement("span", { className: "tooltiptext", id: "myTooltip" }, tooltiptext),
                                React.createElement("i", { className: "edel-icon-copy-icon" }))));
                    }))))) : (React.createElement("div", { className: "mb-genericSidebar" },
            React.createElement(Drawer, { hideScrollbars: true, onClose: function () { return props.setShare(false); }, isVisible: showShareLinks, 
                //className="backgroundcolor_bluedrawer"
                className: "z-index-high backgroundcolor_bluedrawer" },
                React.createElement("div", { className: "social-icons-shareon" }, "Share On"),
                React.createElement("div", { className: "d-flex align-items-center justify-content-center icon-list-mob" },
                    React.createElement("div", { className: "instagram" },
                        React.createElement(InstapaperShareButton, { url: props.value, className: "share_button" },
                            React.createElement(InstapaperIcon, { size: 32 }))),
                    React.createElement("div", { className: "twitter" },
                        React.createElement(TwitterShareButton, { title: "", url: props.value, hashtags: ["hashtag1", "hashtag2"], className: "share_button" },
                            React.createElement(TwitterIcon, { size: 32 }))),
                    React.createElement("div", { className: "gmail" },
                        React.createElement(EmailShareButton, { url: props.value, className: "share_button" },
                            React.createElement(EmailIcon, { size: 32 }))),
                    React.createElement("div", { className: "linkedIn" },
                        React.createElement(LinkedinShareButton, { title: "", url: props.value, className: "share_button" },
                            React.createElement(LinkedinIcon, { size: 32 }))),
                    React.createElement("div", { className: "facebook" },
                        React.createElement(FacebookShareButton, { url: props.value, hashtag: "#hashtag", className: "share_button" },
                            React.createElement(FacebookIcon, { size: 32 }))),
                    React.createElement("div", { className: "whatsapp" },
                        React.createElement(WhatsappShareButton, { title: "", url: props.value, className: "share_button" },
                            React.createElement(WhatsappIcon, { size: 32 })))),
                React.createElement("div", { className: "copyLink" },
                    React.createElement("div", { className: "copyLink_wrap" },
                        React.createElement("h6", null, "Copy this url to share"),
                        React.createElement("div", { className: "copyLink--input" },
                            React.createElement("input", { type: "text", value: props.value, id: "myInput" }),
                            React.createElement("button", { onClick: ClipboardCopy },
                                React.createElement("span", { className: "tooltiptext", id: "myTooltip" }, tooltiptext),
                                React.createElement("i", { className: "edel-icon-copy-icon" })))))))))));
};
export default ShareSocialLinks;
